/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductDtoBase } from "./ProductDtoBase";
import { RoofOverhangStyle } from "./RoofOverhangStyle";

export class RoofOverhangProductDto extends ProductDtoBase {
    style: RoofOverhangStyle;
}
